export default __webpack_public_path__ + "static/media/placeholder.37f07897.png";